module.exports = __webpack_public_path__ + "img/67_3.01f10f1d.png";